// extracted by mini-css-extract-plugin
export default {"tabsContainer":"styles_tabsContainer__espI1","tab":"styles_tab__zMeGi","activeTab":"styles_activeTab__d-VcU","tabLink":"styles_tabLink__KIwNU","tabBadge":"styles_tabBadge__5Gw7l"};